// extracted by mini-css-extract-plugin
export default {"container":"update_container__Yigrv","deleteContainer":"update_deleteContainer__JxMr7","deleteButton":"update_deleteButton__09jtZ","queryEmpty":"update_queryEmpty__3VBGz"};